import styled from "styled-components";

export default styled.div`
  .box-search {
    width: 70%;
    @media (max-width: 959px) {
      width: 100%;
    }
  }
  .box-content-tab {
    width: 30%;
    @media (max-width: 1113px) {
      width: 40%;
    }
  }
  .map-cercle-radius-property {
    position: relative;

    .circle-radius-m:active {
      opacity: 0.7;
    }

    .map-radius-property {
      position: absolute;
      width: 180px;
      height: 50px;
      /* background-color: gray; */
      top: -62px;
      border-radius: 5px;
      margin-left: -10px;
    }
    .box-relative {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: #4c4c4b;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
    }
    .box-relative:after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -66px;
      width: 0;
      height: 0;
      border-top: solid 8px #4c4c4b;
      border-left: solid 8px transparent;
      border-right: solid 8px transparent;
  }
    .button-close-input {
      position: absolute;
      top: -9px;
      right: -9px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #363535;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
    }
    #my-radius {
      width: 80%;
      height: 30px;
      background-color: transparent;
      border: 1px solid #fa4a4d;
      border-radius: 5px;
      padding-left: 5px;
      color: #ffffff;
      &::placeholder {
        color: #ffffff;
        opacity: 1;
      }
      &:focus {
        outline: none;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/screens/MapScreen/styled.js